<template>
  <div class="nav">
    <div class="symbols">
      <div class="hk-symbols">
        <div class="market-name">港股代码</div>
        <div v-for="symbol in symbols.hk" :key="symbol" class="symbol-item">
          <span :class="{ 'active-symbol': symbol === activeSymbol }" @click="activeSymbol = symbol">{{ symbol }}</span>
        </div>
        <div>
          <input
            type="text"
            placeholder="添加港股代码"
            v-model="hkSymbol"
            class="plus"
            @blur="plushkSymbol"
            @keyup.enter="plushkSymbol"
          />
        </div>
      </div>
      <div class="us-symbols">
        <div class="market-name">美股代码</div>
        <div v-for="symbol in symbols.us" :key="symbol" class="symbol-item">
          <span :class="{ 'active-symbol': symbol === activeSymbol }" @click="activeSymbol = symbol">{{ symbol }}</span>
        </div>
        <div>
          <input
            type="text"
            placeholder="添加美股代码"
            v-model="usSymbol"
            class="plus"
            @blur="plususSymbol"
            @keyup.enter="plususSymbol"
          />
        </div>
      </div>
      <div class="hs-symbols">
        <div class="market-name">A股代码</div>
        <div v-for="symbol in symbols.hs" :key="symbol" class="symbol-item">
          <span :class="{ 'active-symbol': symbol === activeSymbol }" @click="activeSymbol = symbol">{{ symbol }}</span>
        </div>
        <div>
          <input
            type="text"
            placeholder="添加A股代码"
            v-model="hsSymbol"
            class="plus"
            @blur="plushsSymbol"
            @keyup.enter="plushsSymbol"
          />
        </div>
      </div>
      <button class="reset-button" @click="resetSymbols">重置</button>
    </div>
    <div class="tabs">
      <template v-for="tab in tabs">
        <div v-if="tab" :key="tab.name" class="tab-item">
          <span @click="goPage(tab)">{{ tab.label }}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hkSymbol: '',
      usSymbol: '',
      hsSymbol: '',
      activeSymbol: '00700.hk',
      symbols: {
        hs: ['600519.sh', '000001.sz', '601336.sh'],
        hk: ['00700.hk', '07552.hk'],
        us: ['baba.us', 'nrgu.us']
      }
    }
  },
  computed: {
    market() {
      return this.$funs.getMarket(this.activeSymbol)
    },
    tabs() {
      let tabs = [
        {
          label: '盘口',
          name: 'bidask',
          path: '/bidask'
        },
        this.market !== 'hs'
          ? {
              label: '新闻',
              name: 'news',
              path: '/news'
            }
          : null,
        {
          label: '公告',
          name: 'announcement',
          path: '/announcement'
        },
        this.market !== 'hs'
          ? {
              label: '研报',
              name: 'report',
              path: '/report'
            }
          : null,
        {
          label: '简况(F10)',
          name: 'f10',
          path: '/f10'
        },
        this.market !== 'hs'
          ? {
              label: 'IPO',
              name: 'ipo',
              path: '/ipo'
            }
          : null,
        this.market === 'hk'
          ? {
              label: '轮证',
              name: 'warrants',
              path: '/warrants'
            }
          : null
      ]
      return tabs
    }
  },
  methods: {
    goPage(tab) {
      this.$router.push({
        path: tab.path,
        query: {
          symbol: this.activeSymbol
        }
      })
    },
    plushkSymbol() {
      this.symbols.hk.push(this.hkSymbol)
      this.hkSymbol = ''
      this.setSymbolsStorage()
    },
    plususSymbol() {
      this.symbols.us.push(this.usSymbol)
      this.usSymbol = ''
      this.setSymbolsStorage()
    },
    plushsSymbol() {
      this.symbols.hs.push(this.hsSymbol)
      this.hsSymbol = ''
      this.setSymbolsStorage()
    },
    resetSymbols() {
      this.symbols = this.$options.data().symbols
      this.setSymbolsStorage()
    },
    setSymbolsStorage() {}
  }
}
</script>
<style lang="scss" scoped>
.nav {
  display: flex;
  text-align: center;
  height: 100vh;
  padding: 30px 0;
  font-size: 15px;
  background: var(--bg-color-2);
  .symbols,
  .tabs {
    flex: 1;
    height: 100%;
  }
  .symbols {
    border-right: 1px solid var(--border-color-1);
  }
  .market-name {
    margin-bottom: 10px;
    color: var(--font-color-3);
  }
  .hk-symbols,
  .us-symbols {
    margin-bottom: 30px;
  }
  .symbol-item,
  .tab-item {
    margin-bottom: 20px;
    cursor: pointer;
  }
  .active-symbol {
    padding: 2px 5px;
    border: 1px solid var(--main-color-1);
  }
  .plus {
    padding: 4px 5px 6px;
    border: 0 dotted var(--border-color-1);
    background: var(--bg-color-1);
    font-size: 12px;
    outline: none;
  }
  .reset-button {
    margin-top: 30px;
  }
}
</style>
